const reportStatus = {
	name: 'Meldungsstatus',
	fields: {},
	processStep: 'Prozessschritt',
	orderHint:
		'Die Reihenfolge entspricht den Spalten im Kanban unter „Offene Anfragen“ und der Status-Auswahl dort. Ziehen Sie einen Status am Griff, um ihn zu verschieben.',
	kanbanHint:
		'Spalten per Ziehen am Spaltenkopf verschieben oder im Status-Menü mit den Pfeilen. Die Reihenfolge der Status legen Sie unter Einstellungen > Definitionen > Meldungsstatus fest.',
	restoreDefault: 'Standard wiederherstellen',
	dragHandle: 'Zum Verschieben ziehen',
	moveUp: 'Nach oben',
	moveDown: 'Nach unten',
	editInAdmin: 'Meldungsstatus in den Einstellungen verwalten',
	position: 'Position {n}',
	process: {
		open: 'Offen',
		processing: 'In Arbeit',
		denied: 'Abgelehnt',
		done: 'Beendet',
	},
}

export default reportStatus
